import { memo } from "react";
import { Link } from "react-router-dom";
import "./ft.css";
import { getProductImageUrl } from "../../../../utils/imageUrl";

function Featurelist({ data, count }) {
	if (!data) return null;
	const firstImage = getProductImageUrl(data, 0);
	const secondImage = getProductImageUrl(data, 1);
	return (
		<li className={count === 1 ? "lg:w-10/12" : "w-full"}>
			<Link to={`/Gowns/id/${data.style}`} state={{ product: data }} aria-label={`View gown style ${data.style}`} className="block focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-[#8a459f]">
				<div className={`relative overflow-hidden bg-gray-100 ${count === 1 ? "lg:w-[300px] lg:h-[400px] md:w-[300px] md:h-[400px] w-full aspect-[4/5]" : "w-full aspect-[4/5]"}`}>
					{firstImage && <img src={firstImage} alt={`Risky gown style ${data.style}`}  className="w-full h-full object-cover object-top img1" />}
					{secondImage && <img src={secondImage} alt="" className="myimg w-full h-full object-cover object-top" />}
				</div>
			</Link>
		</li>
	);
}
export default memo(Featurelist);
